import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import './ReceiptDetails.scss';
import ReceiptDetailsContent from './ReceiptDetailsContent';

interface RenderReceiptDetailsProps {
  setReceipts: (receipts: any[]) => void;
  currentReceipt: any;
  show: boolean;
  onClose: () => void;
  onReceiptSettled?: (receiptId: number) => void;
}

const ReceiptDetails: React.FC<RenderReceiptDetailsProps> = ({
  setReceipts,
  currentReceipt,
  show,
  onClose,
  onReceiptSettled
}) => {
  return (
    <Modal show={show} onHide={onClose} centered className="mp-modal receipt-details-modal-content">
      <Modal.Header className="mp-modal-header">
        <Modal.Title className="mp-modal-title">Detalle del recibo</Modal.Title>
        <button className="mp-modal-close" onClick={onClose}>
          <FaTimes />
        </button>
      </Modal.Header>
      <Modal.Body className="mp-modal-body mp-scrollbar">
        <ReceiptDetailsContent
          setReceipts={setReceipts}
          currentReceipt={currentReceipt}
          show={show}
          onClose={onClose}
          onReceiptSettled={onReceiptSettled}
          readOnly={false}
        />
      </Modal.Body>
      <Modal.Footer className="mp-modal-footer">
        <button className="mp-modal-btn-secondary" onClick={onClose}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReceiptDetails;
